// Packages
import { FlexStyle } from 'react-native';

export const position = (): Record<string, FlexStyle> => ({
	absolute: { position: 'absolute' },
	relative: { position: 'relative' },
});
